// extracted by mini-css-extract-plugin
module.exports = {"marquee":"node-marquee_marquee__uXzYx","children-wrapper":"node-marquee_children-wrapper__AXvyQ","is-animated":"node-marquee_is-animated__1THO0"};